export default __webpack_public_path__ + "static/media/allowable-dependent-care-expenses.c6b22840.svg";